export const DOWNLOAD_CONFIRMED_PROPOSAL_SPINNER_TEST_ID = 'download-confirmed-proposal-spinner-test-id';
export const DOWNLOAD_PDF_TILE_TEST_ID = 'post-submit-download-pdf-tile-test-id';
export const DOWNLOAD_XLSX_TILE_TEST_ID = 'post-submit-download-xlsx-tile-test-id';
